import { IpAddress } from '../Model/IpAddresses';
import { Boitier } from '../Model/Boitier';
import { CompteServer } from '../Model/CompteServer';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

/**
 * 
 * created by  created by AHMED HAYEL 
 * 
 */

@Injectable()
export class ServiceAdminService {

  dns: String = "/ws_server_admin/";
  //dns: String = "http://37.187.171.84:8080/ws_server_admin/";
  //dns: String = "http://localhost:8081/";
  //dns: string = "http://localhost:8080/BackEnd_ServerAdministration/"
  // dns:string="http://localhost:8081/server-management/"
  isAuthenticated: boolean = false;
  USER_TOKEN: string = "";
  TOKEN_PREFIX: string = "rimtel ";
  private headers: Headers;

  ips: IpAddress[] = [];

  constructor(private _http: Http) { }

  //=================================================
  // Authentification
  //=================================================

  /**
    * 
    * Athentification
    * 
    */

  authentificate(login: string, password: string): Observable<any> {
    console.log("dns: "+this.dns);
    return this._http.post(this.dns + "authenticate?username=" + login + "&password=" + password, null).map(res => res.json());
  }

  //=================================================
  // Headers For JWT
  //=================================================

  /**
    * 
    * Headers of any request
    * 
    */
  private getHeaders() {
    this.headers = new Headers();

    this.headers.append('Accept', 'application/json');
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Authorization', this.loadToken());

    return this.headers;
  }
  //=================================================
  // boitier crud
  //=================================================

  /**
    * 
    * Add new Boitiers to server account
    * 
    */

  addBoitiers(idCompteServer: number, nbrBoitiers: number): Observable<any> {
    let options = new RequestOptions({ headers: this.getHeaders() });
    return this._http.post(this.dns + "compteServer/" + idCompteServer + "?nombreBoitier=" + nbrBoitiers, null, options).map(res => res.json())
  }

  /**
    * 
    * Update Boitier
    * 
    */

  updateBoitier(boitier: Boitier, idServer: number, updateType: string): Observable<any> {
    let options = new RequestOptions({ headers: this.getHeaders() });
    return this._http.put(this.dns + "boities?idServer=" + idServer + "&updateType=" + updateType, boitier, options).map(res => res.json());
  }

  /**
    * 
    * Update Boitier
    * 
    */
  lastArchiveOfBoitier(numBoitier: number): Observable<any> {
    let options = new RequestOptions({ headers: this.getHeaders() });
    return this._http.get(this.dns + "boities/" + numBoitier + "/lastArchive", options).map(res => res.json());
  }

  //=================================================
  // Archive boitier crud
  //=================================================

  /**
    * 
    * Get archive from database
    * 
    */
  getArchiveOfBoitier(numboitier: number, limit: number): Observable<any> {
    let options = new RequestOptions({ headers: this.getHeaders() });
    return this._http.get(this.dns + "boities/" + numboitier + "/Archives/" + limit, options).map(res => res.json());

  }


  //=================================================
  // Raw of device
  //=================================================
  getRaws(numBoitier: number, limit: number): Observable<any> {

    let options = new RequestOptions({ headers: this.getHeaders() });
    return this._http.get(this.dns + "boities/" + numBoitier + "/Raw/" + limit, options).map(res => res.json());
  }


  //=================================================
  // Compte Server crud
  //=================================================

  /**
    * 
    * add server account
    * 
    */

  createServerCompte(compteServer: CompteServer): Observable<any> {

    let options = new RequestOptions({ headers: this.getHeaders() });
    return this._http.post(this.dns + "compteServer", compteServer, options).map(res => res.json());
  }

  /**
    * 
    * Get All server account by keyword
    * 
    */

  getAllServerCompte(keyword: string, page: number, size: number): Observable<any> {
    let options = new RequestOptions({ headers: this.getHeaders() });
    return this._http.get(this.dns + "compteServer?keyWord=" + keyword + "&page=" + page + "&size=" + size, options).map(res => res.json());
  }

  /**
    * 
    * Update server account by keyword
    * 
    */
  updateServerCompte(id: number, compteServer: CompteServer): Observable<any> {
    let options = new RequestOptions({ headers: this.getHeaders() });
    return this._http.put(this.dns + "compteServer/" + id, compteServer, options).map(res => res.json());
  }

  /**
    * 
    * Get server account by keyword
    * 
    */
  getBoitierOfAccount(keyWord: string, id: number, page: number, size: number): Observable<any> {
    let options = new RequestOptions({ headers: this.getHeaders() });
    return this._http.get(this.dns + "compteServer/" + id + "/Boitiers?&keyWord=" + keyWord + "&page=" + page + "&size=" + size, options).map(res => res.json());
  }


  /**
   * 
   * Get server account by ID
   * 
   */
  getCompteServerById(id: number): Observable<any> {
    let options = new RequestOptions({ headers: this.getHeaders() });
    return this._http.get(this.dns + "compteServer/" + id, options).map(res => res.json());
  }

  /**
    * 
    * DELETE server account 
    * 
    */
  deleteCompteServer(id: number) {
    let options = new RequestOptions({ headers: this.getHeaders() });
    this._http.delete(this.dns + "compteServer/" + id, options).map(res => res.json()).subscribe(res => {

    });
  }

  /**
    * 
    * extends interval of Boitiers
    * 
    */
  extendIntervalOfBoitiers(idCompteServer: number): Observable<any> {
    let options = new RequestOptions({ headers: this.getHeaders() });
    return this._http.put(this.dns + "compteServer/" + idCompteServer + "/newInterval", null, options).map(res => res.json());
  }

  //=================================================
  // Address IP crud
  //=================================================

  /**
    * 
    * Get All IPs
    * 
    */

  getAllIps(): Observable<any> {


    let options = new RequestOptions({ headers: this.getHeaders() });

    return this._http.get(this.dns + "ips", options).map(res => res.json());
  }

  //=================================================
  // convertion millesconde to string
  //=================================================

  addZero(i) {
    return (i < 10) ? "0" + i : "" + i;
  }
  conversionMilleScondesToString(millesconde: number): string {
    let date: Date;

    date = new Date(millesconde);
    let strDate: string = "";
    strDate = this.addZero(date.getUTCDate()) + "-" + this.addZero(date.getUTCMonth() + 1) + "-" + date.getFullYear();
    return strDate;
  }


  //=================================================
  // Cookies Management
  //=================================================

  saveTokenInStorage(token: string, isAuthenticated: boolean) {
    this.USER_TOKEN = this.TOKEN_PREFIX + token
    localStorage.setItem("tokenAdmin", this.USER_TOKEN);
    localStorage.setItem("isAuthenticateAdmin", "" + isAuthenticated);

  }

  loadToken(): string {

    return localStorage.getItem("tokenAdmin");
  }

  loadTestAuthenticated(): boolean {
    var res = document.cookie.split(";");
    let isAuthenticated: string = "";
    isAuthenticated = localStorage.getItem("isAuthenticateAdmin");
    if (isAuthenticated == "true") {
      return true
    } else {
      return false;
    }
  }

  logoutStorage() {
    localStorage.removeItem("tokenAdmin");
    localStorage.removeItem("isAuthenticateAdmin");
  }
}



// WEBPACK FOOTER //
// ./src/app/Providers/service-admin.service.ts